// extracted by mini-css-extract-plugin
export var activeFilterButton = "_kp-c";
export var backButton = "_kp-4";
export var backIcon = "_kp-5";
export var chevronShortcut = "_kp-6";
export var container = "_kp-1";
export var editor = "_kp-8";
export var editorWrapper = "_kp-7";
export var prefix = "_kp-2";
export var searchIcon = "_kp-3";
export var suffix = "_kp-9";
export var suffixContent = "_kp-a";
export var suffixText = "_kp-b";
export var wrapper = "_kp-0";